import React from 'react';

const ResultNumberCircle = ({ number, isCorrect }) => {
    return (
        <div className={`result-number ${isCorrect ? 'correct' : 'incorrect'}`
        }>{number}</div>
    );
};

export default ResultNumberCircle;